import { CrudForm } from '../shared/CrudPage';
import { departmentService } from '@kss/api';
import type { Department, DepartmentCreate, DepartmentFilter } from '@kss/api';

type F = {
  code: string;
  name: string;
  description: string;
  status: string;
  remarks: string;
  isActive: boolean;
};

const empty: F = {
  code: '',
  name: '',
  description: '',
  status: '',
  remarks: '',
  isActive: true,
};

export default function NewDepartment() {
  return (
    <CrudForm<Department, DepartmentCreate, DepartmentFilter, F>
      title="department"
      service={departmentService}
      idKey="departmentId"
      basePath="/panel/departments"
      emptyForm={empty}
      fields={[
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name', required: true },
        { key: 'description', label: 'Description' },
        { key: 'isActive', label: 'Status', type: 'status' },
      ]}
      fromEntity={(r) => ({
        code: ((r as unknown as Record<string, unknown>).code ?? '') as string,
        name: ((r as unknown as Record<string, unknown>).name ?? '') as string,
        description: ((r as unknown as Record<string, unknown>).description ?? '') as string,
        status: ((r as unknown as Record<string, unknown>).status ?? '') as string,
        remarks: ((r as unknown as Record<string, unknown>).remarks ?? '') as string,
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        departmentId: id,
        code: f.code ? f.code : undefined,
        name: f.name ? f.name : undefined,
        description: f.description ? f.description : undefined,
        status: f.status ? f.status : undefined,
        remarks: f.remarks ? f.remarks : undefined,
        isActive: f.isActive,
      } as Department)}
      validate={(f) => (!f.name.trim() ? 'Name is required' : null)}
    />
  );
}
